import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=ad6b97c6&"
import script from "./CourseEdit.vue?vue&type=script&lang=js&"
export * from "./CourseEdit.vue?vue&type=script&lang=js&"
import style0 from "./CourseEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports